import React, { useEffect, useState, useMemo, useContext, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { all_routes } from "./router/all_routes";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import {
    FiEye,
    FiCheck,
    FiX,
    FiDownload,
    FiFileText,
    FiUser,
    FiCalendar,
    FiClock,
    FiCheckCircle,
    FiXCircle,
    FiAlertCircle,
} from "react-icons/fi";
import {
    FaFileAlt,
    FaUserGraduate,
    FaBriefcase,
    FaSchool,
    FaPhone,
    FaEnvelope,
    FaUser,
    FaArrowCircleLeft,
} from "react-icons/fa";
import {
    Modal,
    Button,
    Form,
    Row,
    Col,
    Card,
    Container,
    Badge,
    Accordion,
    Pagination,
    Spinner,
} from "react-bootstrap";
import html2pdf from "html2pdf.js";
import Header from "./Header";
import moment from "moment";
import { ProductContext } from "../context/AppContext";
import axios from "axios";

const MarksheetView = () => {
    const location = useLocation();
    const { SchoolData, classSections22 } = useContext(ProductContext)
    const {
        session_id,
        class_section_id,
        exam_type_ids,
        visibilityOptions: adminVisibilityOptions,
        studentTransferData: adminStudentTransferData,
        selectedStudentId,
        // Student web (Exam.js) sends these instead of the admin fields
        student_id,
        isSkillView,
        isCurriculumView,
        isObservationView,
        examTypeLatestDates,
    } = location.state || {};

    const visibilityOptions = adminVisibilityOptions || {
        is_skill_visible: isSkillView === true,
        is_curr_visible: isCurriculumView === true,
        is_oberv_visible: isObservationView === true,
    };

    const matchedDate =
        examTypeLatestDates
            ?.filter(exam => exam_type_ids?.includes(exam.exam_type_id))
            ?.map(exam => exam.latest_exam_date)?.[0] || "-";

    // Mobile: sheet A4 (210mm) width ki hai, screen me fit karne ke liye scale karo.
    // transform wrapper par hai, #all-marksheets par nahi, taaki print/PDF unaffected rahe.
    const fitWrapRef = useRef(null);
    const fitInnerRef = useRef(null);
    const [sheetScale, setSheetScale] = useState(1);
    const [sheetHeight, setSheetHeight] = useState(null);

    useEffect(() => {
        const wrap = fitWrapRef.current;
        const inner = fitInnerRef.current;
        if (!wrap || !inner) return;

        const update = () => {
            const sheetWidth = inner.offsetWidth || 1;
            const scale = Math.min(1, wrap.clientWidth / sheetWidth);
            setSheetScale(scale);
            setSheetHeight(inner.offsetHeight * scale);
        };

        update();
        const ro = new ResizeObserver(update);
        ro.observe(wrap);
        ro.observe(inner);
        return () => ro.disconnect();
    }, []);

    const [studentAttendance, setStudentAttendance] = useState(null);
    const studentTransferData =
        adminStudentTransferData ||
        (Array.isArray(studentAttendance) ? studentAttendance : null);

    console.log(visibilityOptions, 'is_previousclass data');
        console.log(visibilityOptions?.skill_exam_types, 'skill_exam_types data');


    const formattedClassSectionsFilter = (classSections22?.data || []).map(item => ({
        value: item.id, // class_section_id
        label: `${item.class_name} - ${item.section_name}`,
    }));

    const getClassSectionLabel = (classSectionId) => {
        const found = formattedClassSectionsFilter.find(
            item => item.value === classSectionId
        );
        return found ? found.label : "-";
    };
    const container = {
        width: "210mm",          // A4 width
        minHeight: "297mm",      // A4 height
        margin: "0 auto",
        padding: "10mm",
        boxSizing: "border-box",
        // border: "1px solid #000",
        background: "#fff",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        lineHeight: "18px",
        pageBreakAfter: "always",
        position: 'relative',
    };

    const center = { textAlign: "center" };

    const bigTitle = {
        fontSize: "22px",
        fontWeight: "bold",
        color: '#000'
    };

    const subTitle = {
        fontSize: "14px",
        marginTop: "5px",
        color: '#000'
    };

    const table = {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "10px",
        color: '#000',
        tableLayout: "fixed"
    };
    const table1 = {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "2px",
        color: '#000',
        tableLayout: "fixed"
    };

    const th = {
        border: "1px solid black",
        padding: "6px",
        background: "#eaeaea",
        fontWeight: "bold",
        textAlign: "center",
        color: '#000',
        fontSize: '12px'
    };

    const td = {
        border: "1px solid black",
        padding: "6px",
        textAlign: "center",
        color: '#000',
        fontSize: '12px'
    };

    const tdLeft = {
        border: "1px solid black",
        padding: "6px",
        textAlign: "left",
        color: '#000'
    };
    const tdLeft2 = {
        border: "1px solid black",
        padding: "6px",
        textAlign: "left",
        color: '#000',
        fontSize: "12px"
    };

    const row = {
        display: "flex",
        justifyContent: "space-between",
        margin: "5px 0",
        color: '#000'
    };

    const hasVisibilityOptions =
    visibilityOptions?.is_skill_visible === true ||
    visibilityOptions?.is_oberv_visible === true ||
    visibilityOptions?.is_previousclass === true
    // visibilityOptions?.is_remarks === true;

    const signatureRow = {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "100px",      // space to sign above the line
        padding: "0px 40px",
        color: '#000',
        marginBottom: '15px'
    };
    const signatureRowwithoutvisibilityOptions = {
        display: "flex",
        justifyContent: "space-between",
        marginTop: "15px",
        padding: "0px 40px",
        color: '#000',
        marginBottom: '100px'

    };

    // Marksheet is wrapped in a table so the <tfoot> footer repeats on every
    // printed page when the content overflows one A4 page.
    const pageTable = {
        width: "100%",
        height: "277mm",         // A4 height minus container padding
        borderCollapse: "collapse",
        border: "none",
    };
    const pageBodyCell = {
        verticalAlign: "top",
        padding: 0,
        border: "none",
    };
    const pageFooterCell = {
        verticalAlign: "bottom",
        padding: "10px 5px 0px",
        border: "none",
        height: "1px",
    };

    const signatureBlock = {
        textAlign: "center",
        color: '#000'
    };
    const cell = {
        border: "1px solid #000",
        padding: "6px",
        color: '#000'
    };
    const cell1 = {
        border: "1px solid #000",
        padding: "3px",
        color: '#000'
    };

    const [students, setStudents] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [loading, setLoading] = useState(false);
    const studentIdsParam = selectedStudentId?.length
        ? selectedStudentId.map(s => s.id).join(",")
        : student_id;
    const navigate = useNavigate();


    const [examPaperMap, setExamPaperMap] = useState([]);

    const fetchExamPaperMap = async () => {
        setLoading(true);

        try {
            const response = await axios.get(
                "https://api.mirai.healthcare/api/exam-paper-map",
                {
                    headers: {
                        "Content-Type": "application/json",
                        "x-auth": localStorage.getItem("token"),
                    },
                }
            );

            if (response.data.success) {
                setExamPaperMap(response.data.responseData);
                // console.log(response.data.responseData);
            }
        } catch (error) {
            console.error("Exam Paper Map Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const paperNameMap = useMemo(() => {
        const map = {};

        examPaperMap.forEach((cls) => {
            cls.exam_types?.forEach((exam) => {
                exam.papers?.forEach((paper) => {
                    map[paper.paper_id] = paper.paper_name;
                });
            });
        });

        return map;
    }, [examPaperMap]);



    useEffect(() => {
        fetchExamPaperMap();
        getMarksheetData();
        if (!adminStudentTransferData && student_id) {
            getMarksheetDataAttendance();
        }
    }, []);

    const getMarksheetDataAttendance = async () => {
        try {
            const res = await fetch(
                `https://api.mirai.healthcare/api/fee-service/due-master/due-fee/students?session_id=${session_id}&cls_sec_id=${class_section_id}&date=${matchedDate}&student_id=${student_id}`,
                {
                    headers: {
                        "accept": "application/json",
                        "x-auth": localStorage.getItem("token"),
                    },
                }
            );

            const result = await res.json();
            if (result) {
                setStudentAttendance(result);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getMarksheetData = async () => {
        try {
            setLoading(true);

            const res = await fetch(
                `https://api.mirai.healthcare/api/exam/result/student/marksheet?session_id=${session_id}&exam_type_ids=${exam_type_ids}&isSkillView=${visibilityOptions?.is_skill_visible}&isCurriculumView=${visibilityOptions?.is_curr_visible}&isObservationView=${visibilityOptions?.is_oberv_visible}&cls_sec_id=${class_section_id}&studentIds=${studentIdsParam}`,

                {
                    headers: {
                        "accept": "application/json",
                        "x-auth": localStorage.getItem("token"),
                    },
                }
            );

            const result = await res.json();

            if (result) {
                setStudents(result?.message);
                setSelectedStudent(result?.message);
            }
        } catch (error) {
            console.log(error);
        }
        finally {
            setLoading(false);
        }
    };

const getLatestResult = (studentResult = [], studentId) => {
    if (!Array.isArray(studentResult)) return null;

    const valid = studentResult.filter(
        r =>
            r.student_id === studentId &&
            r.mark_obtain !== null &&
            r.mark_obtain !== undefined &&
            r.mark_obtain !== "" &&
            r.status !== "rejected"
    );

    if (!valid.length) return null;

    // ==========================================
    // 1. NORMAL RESULTS
    // ==========================================
    const normalResults = valid.filter(
        r => r.is_reexam !== true
    );

    let latestNormal = null;

    if (normalResults.length > 0) {

        // First preference: latest APPROVED
        const approvedNormal = normalResults.filter(
            r => r.status === "approved"
        );

        if (approvedNormal.length > 0) {
            latestNormal =
                approvedNormal[approvedNormal.length - 1];
        } else {
            // Approved nahi hai → latest NULL status
            const nullStatusNormal = normalResults.filter(
                r => r.status === null
            );

            if (nullStatusNormal.length > 0) {
                latestNormal =
                    nullStatusNormal[nullStatusNormal.length - 1];
            }
        }
    }

    // ==========================================
    // 2. RE-EXAM RESULTS
    // ==========================================
    const reExamResults = valid.filter(
        r => r.is_reexam === true
    );

    let highestReExam = null;

    if (reExamResults.length > 0) {
        highestReExam = reExamResults.reduce(
            (highest, current) =>
                Number(current.mark_obtain) >
                Number(highest.mark_obtain)
                    ? current
                    : highest
        );
    }

    // ==========================================
    // 3. NORMAL vs RE-EXAM
    //    Highest mark select karo
    // ==========================================
    if (latestNormal && highestReExam) {
        return Number(latestNormal.mark_obtain) >=
            Number(highestReExam.mark_obtain)
            ? latestNormal
            : highestReExam;
    }

    // Sirf Normal available
    if (latestNormal) {
        return latestNormal;
    }

    // Sirf Re-exam available
    if (highestReExam) {
        return highestReExam;
    }

    return null;
};

const getStudentExamMark = (studentResults = [], studentId) => {
    const latestResult = getLatestResult(
        studentResults,
        studentId
    );

    if (!latestResult) return 0;

    return Number(latestResult.mark_obtain) || 0;
};

    const calculatePercentage = (obtained, max) => {
        if (!max || max === 0) return 0;

        return Math.floor(
            (obtained / max) * 100
        );
    };

    const getGradeFromLegend = (
        percentage,
        gradingLegend = []
    ) => {

        const percent = Math.floor(Number(percentage));

        const gradeObj = gradingLegend.find(g => {

            const min = Number(g.min_percentage);
            const max = Number(g.max_percentage);

            return percent >= min && percent <= max;
        });

        return gradeObj?.grade || "-";
    };


    const extractCurriculum = (examTypes = [], studentId) => {
        const map = {};

        examTypes.forEach(exam => {
            exam.curriculam?.forEach(c => {
                const title = c.curr_sub?.title;
                if (!title) return;

                if (!map[title]) {
                    map[title] = {
                        title,
                        grades: {}
                    };
                }

                // grade exam-wise
                if (c.studentResult?.grade) {
                    map[title].grades[exam.exam_type] = c.studentResult.grade;
                }
            });
        });

        return Object.values(map);
    };

    const getAbsentLeaveDisplay = (res) => {
        const attendance = res?.attendence || res?.attendence_approval;

        if (!attendance) return "-";

        if (attendance.status === "absent") {
            return "A";
        }

        if (attendance.status === "leave") {
            return attendance.leave_type === "medical" ? "ML" : "L";
        }

        return "-";
    };


    const getSubjectWeightedMax = (examTypes = []) => {
        return examTypes.reduce((sum, exam) => {
            return sum + Number(exam.weightage || 0);
        }, 0);
    };
    const getWeightedMarks = (obtained, weightage, maxMarks) => {
        if (obtained === null || obtained === undefined || isNaN(obtained)) return 0;

        // If weightage = maxMarks, just return obtained
        if (!weightage || !maxMarks) return 0;

        // Weighted calculation
        return Number(((obtained / maxMarks) * weightage).toFixed(2));
    };

    // mark_obtain / max_marks * weightage (subject + exam type level)
    const toWeighted = (marks, details) => {
        const m = Number(marks);
        if (marks === null || marks === undefined || marks === "" || isNaN(m)) return marks;

        const max = Number(details?.max_marks || 0);
        const weightage = Number(details?.weightage || 0);
        if (!max || !weightage) return m;

        return Number(((m / max) * weightage).toFixed(2));
    };

    // Normal (latest approved/null) vs Re-exam => jo highest ho (Subject Total wala same logic)
    const getHighestExamMarks = (details) => {
        // buildSubjectRows me paper-wise best ka sum (multi-paper subject ke liye sahi)
        if (details?.bestObtained !== undefined && details?.bestObtained !== null) {
            return Number(details.bestObtained);
        }

        let finalMarks = Number(details?.obtained || 0);

        const validReExams = (details?.reExamList || [])
            .filter(
                r =>
                    r.status !== "rejected" &&
                    r.marks !== null &&
                    r.marks !== undefined &&
                    !isNaN(Number(r.marks))
            )
            .map(r => Number(r.marks));

        if (validReExams.length > 0) {
            finalMarks = Math.max(finalMarks, ...validReExams);
        }

        return finalMarks;
    };

    // Header: har subject ka weightage (multi-paper => sum), un mein se highest
    // e.g. Hindi 20, English 25 => PA1 (25)
    const getExamHeaderWeightage = (exam, rows = []) => {
        const values = rows
            .filter(r => !r.isGradeInputType && !r.is_display_grade)
            .map(r => Number(r.examDetails?.[exam.exam_type]?.weightage || 0));

        const max = values.length ? Math.max(...values) : 0;
        return max || Number(exam?.weightage || 0);
    };

    const getSubjectWeightedObtained = (row, examTypes) => {
        let total = 0;
        examTypes.forEach(exam => {
            const details = row.examDetails?.[exam.exam_type];
            if (!details || details.obtained === null) return;

            total += getWeightedMarks(details.obtained, exam.weightage, details.max_marks);
        });

        // Convert to number explicitly
        return parseFloat(total.toFixed(2)); // ✅ parseFloat, not Number(toFixed())
    };


    const getSubjectTotalMarks = (row, examColumns) => {
        let total = 0;

        examColumns.forEach(exam => {
            const val = row.exams?.[exam.exam_type];

            if (typeof val === "number" && !isNaN(val)) {
                total += val;
            }
        });

        return Number(total.toFixed(2));
    };

    const getSubjectMaxMarks = (row, examColumns) => {
        if (row.isGradeInputType) return "-";

        return examColumns.reduce((sum, exam) => {
            return sum + Number(exam.weightage || 0);
        }, 0);
    };

    const getCorrectSubjectTotal = (row, examColumns) => {
        let total = 0;

        examColumns.forEach(exam => {
            const val = row.exams?.[exam.exam_type];

            if (typeof val === "number" && !isNaN(val)) {
                total += val;
            }
        });

        return Number(total.toFixed(2));
    };

    const getCorrectSubjectMax = (row, examColumns) => {
        // if (row.isGradeInputType) return "-";

        return examColumns.reduce(
            (sum, exam) => sum + Number(exam.weightage || 0),
            0
        );
    };

    const getSubjectTotalWithWeightage = (row, examColumns) => {
        let total = 0;

        examColumns.forEach(exam => {
            const details = row.examDetails?.[exam.exam_type];

            if (
                details &&
                typeof details.obtained === "number" &&
                details.max_marks
            ) {

                const weighted =
                    getWeightedMarks(
                        details.obtained,
                        details.weightage, // ✅ summed weightage
                        details.max_marks
                    );

                total += weighted;
            }
        });

        return total > 0 ? total.toFixed(2) : "-";
    };

    const isSubjectNotMarked = (row, examColumns) => {
        return examColumns.every(exam => {
            const val = row.exams?.[exam.exam_type];
            return val === "-" || val === null || val === undefined;
        });
    };

    const extractReExamMarks = (studentResult = [], maxMarks) => {

        const original = studentResult?.find(
            r => r.is_reexam === false && r.mark_obtain !== null
        );

        // console.log(studentResult, 'studentResult all data');


        const reExamList = studentResult?.filter(r => r.is_reexam === true && r.mark_obtain !== null)
            .map((r, index) => ({
                tag: `Re${index + 1}`,
                marks: Number(r.mark_obtain),
                max: maxMarks,
                examName: r?.ref_exam?.name || "Re-Exam",
                status: r.status,
                is_reexam: r.is_reexam,
                paperName: r?.paper_id,
            }));

        return {
            originalMarks: original ? Number(original.mark_obtain) : null,
            originalExam: original?.ref_exam?.name,
            reExamMarks: reExamList

        };
    };
    const extractStudentResultHistory = (studentResult = [], maxMarks) => {
        return studentResult?.filter(
            r =>
                r.mark_obtain !== null &&
                r.status !== "rejected"
        )
            .map((r, index) => ({
                tag: r.is_reexam ? `Re${index}` : "Main",
                is_reexam: r.is_reexam,
                marks: Number(r.mark_obtain),
                max: maxMarks,
                attendance: r.attendence || r.attendence_approval,
                examName: r.ref_exam?.name || "Main Exam",
                status: r.status
            }));
    };
    const getSubjectPaperWiseMax = (row) => {

        let totalMax = 0;

        Object.values(row.examDetails || {}).forEach(details => {

            if (Array.isArray(details.paperWiseCalculation)) {

                details.paperWiseCalculation.forEach(p => {

                    totalMax += Number(p.weightage || 0);

                });
            }
        });

        return totalMax;
    };

    const buildSubjectRows = (
        studentData,
        gradingLegend = []
    ) => {

        const subjectMap = {};

        const examColumns =
            studentData.exam_type?.filter(
                e => e.exam_type !== "Overall"
            );

        studentData.exam_type.forEach((exam) => {

            if (exam.exam_type === "Overall") return;

            exam.result?.forEach((res) => {

                const subjectId =
                    res?.subject_paper?.subject?.id ||
                    res?.paper?.subject_id ||
                    res?.paper_id;

                const subjectName =
                    res?.subject_paper?.subject?.name ||
                    res?.paper?.name ||
                    "Unknown Subject";

                if (!subjectId) return;
                // console.log("Subject:", subjectName);
                // console.log("Paper:", res?.subject_paper?.paper_name || res?.paper?.name);
                // console.log("studentResult:", res.studentResult);


                if (!subjectMap[subjectId]) {

                    subjectMap[subjectId] = {
                        subject: subjectName,
                        subject_id: subjectId,
                        exams: {},
                        examDetails: {},
                        maxMarks: 0,
                        total: 0,
                        percentage: 0,
                        grade: "-",
                        isGradeInputType: false,
                        is_display_grade:
                            res?.is_display_grade || false,
                        examPaperOrder:
                            res?.subject_paper?.examPaperOrder ||
                            res?.paper?.examPaperOrder ||
                            999
                    };
                }

                const latest =
                    getLatestResult(
                        res.studentResult,
                        studentData.student_id
                    );
                // console.log(
                //     res.subject_paper?.subject?.name,
                //     latest
                //     , "Latest Total");


                // Grade input subjects
                if (res.is_grade_input_type) {

                    subjectMap[subjectId]
                        .isGradeInputType = true;

                    // Grade input me mark_obtain null hota hai, isliye
                    // getLatestResult use nahi kar sakte - grade wala latest result lo
                    const gradeResults = (res.studentResult || []).filter(
                        r =>
                            r.student_id === studentData.student_id &&
                            r.status !== "rejected" &&
                            r.grade
                    );
                    const latestGrade =
                        gradeResults[gradeResults.length - 1]?.grade;

                    subjectMap[subjectId]
                        .exams[exam.exam_type] =
                        latestGrade || latest?.grade || "-";

                    // Overall grade ke liye is exam ka weightage (multi-paper => sum)
                    const gradePaperWeightage = Number(
                        res?.weightage ??
                        res?.subject_paper?.weightage ??
                        res?.paper?.weightage ??
                        0
                    ) || 0;
                    const gw = subjectMap[subjectId].gradeWeightage || {};
                    gw[exam.exam_type] = (gw[exam.exam_type] || 0) + gradePaperWeightage;
                    subjectMap[subjectId].gradeWeightage = gw;

                    return;
                }

                if (
                    !subjectMap[subjectId]
                        .examDetails[exam.exam_type]
                ) {

                    subjectMap[subjectId].examDetails[exam.exam_type] = {

                        obtained: null,
                        max_marks: 0,
                        min_marks: 0,
                        weightage: 0,
                        attendance: null,

                        // ✅ NEW
                        ref_exam: null,
                        ref_marks: null,
                        grade: null,
                        reExamList: []
                    };
                }

                const details =
                    subjectMap[subjectId]
                        .examDetails[exam.exam_type];

                const reExamData = extractReExamMarks(
                    res.studentResult,
                    res?.max_marks
                );

                const history = extractStudentResultHistory(
                    res.studentResult,
                    res.max_marks
                );

                details.resultHistory = history;

                details.originalMarks =
                    reExamData.originalMarks;

                details.originalExam =
                    reExamData.originalExam;

                // details.reExamList =
                //     reExamData.reExamMarks || [];

                details.reExamList = [
                    ...(details?.reExamList || []),
                    ...(reExamData?.reExamMarks || [])
                ];



                // ✅ save ref exam details
                details.ref_exam =
                    latest?.ref_exam || null;

                // ✅ save ref marks
                details.ref_marks =
                    latest?.mark_obtain
                        ? Number(latest.mark_obtain)
                        : null;

                details.grade =
                    latest?.grade || null;


                const isMedicalLeave =
                    latest?.attendence?.status === "leave"
                    &&
                    latest?.attendence?.leave_type === "medical";
                const attendance =
    res?.attendence ||
    res?.attendence_approval ||
    null;

const attendanceStatus =
    attendance?.status?.toLowerCase();

const obtainedMarks =
    isMedicalLeave
        ? null
        : attendanceStatus === "absent"
            ? 0
            : latest?.mark_obtain !== null &&
              latest?.mark_obtain !== undefined &&
              latest?.mark_obtain !== ""
                ? Number(latest.mark_obtain)
                : null;


                // console.log(
                //     "Obtained",
                //     obtainedMarks,
                //     details
                // );

                const maxMarks =
                    Number(res?.max_marks || 0);
                if (attendanceStatus === "absent") {
    details.obtained = details.obtained ?? 0;
} else if (
    obtainedMarks !== null &&
    obtainedMarks !== undefined &&
    !isNaN(obtainedMarks)
) {
    details.obtained = (details.obtained ?? 0) + obtainedMarks;
}

                // Paper-wise best (original vs is paper ka highest re-exam), phir subject me sum
                // Multi-paper subject me alag papers ke re-exam marks ka max nahi lena hai
                const paperReExams = (reExamData?.reExamMarks || [])
                    .filter(r => r.status !== "rejected" && !isNaN(Number(r.marks)))
                    .map(r => Number(r.marks));
                const paperOriginal =
                    attendanceStatus === "absent" ? 0 : obtainedMarks;
                let paperBest = null;
                if (paperOriginal !== null || paperReExams.length > 0) {
                    paperBest = Math.max(
                        Number(paperOriginal || 0),
                        ...paperReExams
                    );
                    details.bestObtained = (details.bestObtained ?? 0) + paperBest;
                }


                details.max_marks += Number(maxMarks || 0);
                details.min_marks += Number(res?.min_marks || 0);
                // weightage API se string aata hai ("20", "25")
                const paperWeightage = Number(
                    res?.weightage ??
                    res?.subject_paper?.weightage ??
                    res?.paper?.weightage ??
                    0
                ) || 0;

                // Multi-paper subject: saare papers ka weightage sum
                details.weightage += paperWeightage;

                // Paper-wise weighted mark_obtain vs weighted min_marks (Red Line ke liye)
                // weighted = value / max_marks * weightage (weightage na ho to raw value)
                const paperMin = Number(res?.min_marks || 0);
                const toPaperWeighted = (val) =>
                    maxMarks && paperWeightage
                        ? Number(((val / maxMarks) * paperWeightage).toFixed(2))
                        : Number(val);
                const weightedObtained =
                    paperBest !== null ? toPaperWeighted(paperBest) : null;
                const weightedMin = toPaperWeighted(paperMin);
                const paperBelowMin =
                    !isMedicalLeave &&
                    weightedObtained !== null &&
                    paperMin > 0 &&
                    weightedObtained < weightedMin;

                details.papers = [
                    ...(details.papers || []),
                    {
                        paper_id: res?.paper_id,
                        obtained: paperBest,
                        max_marks: maxMarks,
                        min_marks: paperMin,
                        weightage: paperWeightage,
                        weightedObtained,
                        weightedMin,
                        belowMin: paperBelowMin,
                    },
                ];
                // details.weightedMin = Number(
                //     ((details.weightedMin || 0) + weightedMin).toFixed(2)
                // );
                // details.belowMin = Boolean(details.belowMin || paperBelowMin);

                 
                if (!isMedicalLeave && weightedObtained !== null) {
                    details.weightedObtained = Number(
                        ((details.weightedObtained || 0) + weightedObtained).toFixed(2)
                    );
                    details.weightedMin = Number(
                        ((details.weightedMin || 0) + weightedMin).toFixed(2)
                    );
                }
                details.belowMin =
                    details.weightedMin > 0 &&
                    details.weightedObtained !== undefined &&
                    details.weightedObtained < details.weightedMin;


                // details.attendance =
                //     res?.attendence ||
                //     res?.attendence_approval ||
                //     null;
                details.attendance = attendance;
                const summedObtained = details.obtained;
                const summedMax = details.max_marks;

                if (res?.is_display_grade) {

    // No result / no marks for any paper => "-"
    if (
        summedObtained === null ||
        summedObtained === undefined ||
        isNaN(summedObtained)
    ) {
        subjectMap[subjectId].exams[exam.exam_type] = "-";
    }

    // Absent in all papers => show 0 directly
    else if (attendanceStatus === "absent" && summedObtained === 0) {
        subjectMap[subjectId].exams[exam.exam_type] = 0;
    }

    // Actual marks => calculate grade on summed marks
    else {
        const percentage = calculatePercentage(
            summedObtained,
            summedMax
        );

        const convertedGrade = getGradeFromLegend(
            percentage,
            gradingLegend
        );

        subjectMap[subjectId].exams[exam.exam_type] =
            convertedGrade || "-";
    }

} else {
    subjectMap[subjectId].exams[exam.exam_type] =
        summedObtained !== null && summedObtained !== undefined
            ? Number(summedObtained.toFixed(2))
            : "-";
}

            });
        });

        const getOverallGradeFromExamGrades = (row) => {
    let obtained = 0;
    let max = 0;

    examColumns.forEach((exam) => {
        const details = row.examDetails?.[exam.exam_type];

        if (!details) return;

        const examObtained = Number(details.obtained);
        const examMax = Number(details.max_marks || 0);

        // Valid marks nahi hain
        if (
            details.obtained === null ||
            details.obtained === undefined ||
            details.obtained === "" ||
            !Number.isFinite(examObtained) ||
            !examMax
        ) {
            return;
        }

        obtained += examObtained;

        max += examMax;
    });

    if (!max) return "-";

    const percentage = calculatePercentage(
        obtained,
        max
    );

    return getGradeFromLegend(
        percentage,
        gradingLegend
    );
};

        Object.values(subjectMap)
            .forEach((row) => {

                // Paper weightage na mile to exam type weightage, warna max_marks
                examColumns.forEach((exam) => {
                    const details = row.examDetails?.[exam.exam_type];
                    if (details && !details.weightage) {
                        details.weightage =
                            Number(exam.weightage || 0) || Number(details.max_marks || 0);
                    }
                });

                if (row.is_display_grade || row.isGradeInputType) {

                    row.maxMarks = "-";
                    row.total = "-";

                    row.grade = getOverallGradeFromExamGrades(row);

                    return;
                }


                // ML ya Leave tabhi mana jayega jab tak marks obtain na hue hon (obtained null ya 0 ho aur status leave ho)
                const hasMedicalLeave = Object.values(row.examDetails || {}).some(
                    d => d?.attendance?.status === "leave" &&
                        d?.attendance?.leave_type === "medical" &&
                        (d.obtained === null || d.obtained === 0) // ✅ Agar marks hain toh ML ignore hoga
                );

                let obtained = 0;
let max = 0;

examColumns.forEach((exam) => {
    const details = row.examDetails?.[exam.exam_type];

    if (!details) return;

    // RE-EXAM LOGIC: paper-wise original vs re-exam => highest
    const finalMarks = getHighestExamMarks(details);

    // Weighted marks
    obtained += toWeighted(
        finalMarks,
        details
    );

    max += Number(details.weightage || 0);
});

obtained = Number(obtained.toFixed(2));
max = Number(max.toFixed(2));

                const percentage =
                    calculatePercentage(
                        obtained,
                        max
                    );

                const grade =
                    getGradeFromLegend(
                        percentage,
                        gradingLegend
                    );


                row.maxMarks = max;
                row.total = obtained;
                row.percentage = percentage;
                row.grade = grade;

            });


        // return Object.values(subjectMap);
        // return Object.values(subjectMap);

        return Object.values(subjectMap).sort((a, b) => {

            // 1️⃣ Pehle non-grade display
            if (a.is_display_grade !== b.is_display_grade) {
                return a.is_display_grade ? 1 : -1;
            }

            // 2️⃣ Exam paper order
            const orderA =
                a.examPaperOrder ??
                a.paper_order ??
                a.exam_order ??
                999;

            const orderB =
                b.examPaperOrder ??
                b.paper_order ??
                b.exam_order ??
                999;

            return orderA - orderB;
        });
    };

    const subjectRowsMap = useMemo(() => {
        if (!students?.data) return {};

        const result = {};
        students?.data?.forEach((student) => {
            result[student?.student_id] = buildSubjectRows(student);
        });

        return result;
    }, [students]);


    const getStudentTotal = (subjectRows) => {
        return subjectRows.reduce((sum, row) => sum + Number(row.total || 0), 0);
    };

    const calculateColumnTotals = (
        subjectRows,
        examTypes,
        gradingLegend
    ) => {

        const totals = {
            exams: {},
            max: 0,
            total: 0,
            percentage: 0,
            grade: "-"
        };

        // Initialize all exam type column totals with 0
        examTypes.forEach(exam => {
            totals.exams[exam.exam_type] = 0;
        });

        subjectRows.forEach(row => {
            if (row.is_display_grade || row.isGradeInputType) return;

            let subjectObtained = 0;
            let subjectMax = 0;

            examTypes.forEach(exam => {
                const details = row.examDetails?.[exam.exam_type];
                if (!details) return;

                subjectMax += Number(details.weightage || 0);

                const finalMarksForThisExam = getHighestExamMarks(details);

                const isMedicalLeaveWithoutMarks =
                    details?.attendance?.status === "leave" &&
                    details?.attendance?.leave_type === "medical" &&
                    (finalMarksForThisExam === 0 || finalMarksForThisExam === null);


                if (!isMedicalLeaveWithoutMarks) {
                    const weightedMarks = toWeighted(finalMarksForThisExam, details);
                    subjectObtained += weightedMarks;
                    totals.exams[exam.exam_type] = Number(
                        (totals.exams[exam.exam_type] + weightedMarks).toFixed(2)
                    );
                }
            });

            totals.total += subjectObtained;
            totals.max += subjectMax;
        });


        const isAllSubjectsEmpty = subjectRows.every(row =>
            Object.values(row.examDetails || {}).every(
                d => d?.attendance?.status === "leave" &&
                    d?.attendance?.leave_type === "medical" &&
                    (!d.obtained && (!d?.reExamList || d?.reExamList?.length === 0))
            )
        );

        if (isAllSubjectsEmpty && totals.total === 0) {
            totals.exams = Object.fromEntries(examTypes.map(exam => [exam.exam_type, "-"]));
            totals.total = "-";
            totals.percentage = "-";
            totals.grade = "-";
            return totals;
        }

        // 5️⃣ Final Calculation & Decimal Format Support (e.g., 117.5)
        totals.total = Number(totals.total.toFixed(2));
        totals.max = Number(totals.max.toFixed(2));

        totals.percentage = totals.max
            ? Number(((totals.total / totals.max) * 100).toFixed(2))
            : 0;

        totals.grade = getGradeFromLegend(
            totals.percentage,
            gradingLegend
        );

        return totals;
    };




    const getPercentage = (obtained, max) => {
        if (!max) return 0;
        return ((obtained / max) * 100).toFixed(2);
    };

    const getCurriculumData = (studentResults = [], studentId) => {
        const valid = studentResults.find(
            r => r.student_id === studentId && Array.isArray(r.curr_sub)
        );

        return valid?.curr_sub || [];
    };


    const buildCurriculumRows = (studentData) => {
        const map = {};

        studentData?.exam_type?.forEach(exam => {
            exam.curriculam?.forEach(c => {
                const title = c.curr_sub?.title;
                if (!title) return;

                if (!map[title]) {
                    map[title] = {
                        title,
                        grades: {}
                    };
                }

                if (c.studentResult?.grade) {
                    map[title].grades[exam.exam_type] = c.studentResult.grade;
                }
            });
        });

        return Object.values(map);
    };

    const getSkillExamColumns = (studentData) => {
    const examTypes = studentData?.exam_type || [];
    const skillExamTypes = visibilityOptions?.skill_exam_types || [];

    console.log(
        skillExamTypes,
        "skill_exam_types data"
    );

    // skill_exam_types se IDs normalize karo
    const skillExamIds = skillExamTypes
        .map((item) => {
            if (typeof item === "object") {
                return (
                    item?.id ??
                    item?.exam_type_id ??
                    item?.exam_id
                );
            }

            return item;
        })
        .filter(
            (id) => id !== null && id !== undefined && id !== ""
        )
        .map((id) => String(id));

    return examTypes
        .filter((exam) => exam?.exam_type !== "Overall")
        .filter((exam) => {
            const examId =
                exam?.id ??
                exam?.exam_type_id ??
                exam?.exam_id;

            return skillExamIds.includes(String(examId));
        })
        // .slice()
        // .reverse();
};

  const buildSkillRows = (studentData) => {
    const skillMap = {};

    const examColumns = getSkillExamColumns(studentData);

    examColumns.forEach((exam) => {
        const skills = exam?.skills || [];

        skills.forEach((skill) => {
            const skillCategory =
                skill?.skills?.skill_category ||
                skill?.skill_category ||
                skill?.skills?.name ||
                skill?.name;

            if (!skillCategory) return;

            if (!skillMap[skillCategory]) {
                skillMap[skillCategory] = {
                    skillCategory,
                    grades: {}
                };
            }

            const grade = skill?.studentResult?.grade;

            skillMap[skillCategory].grades[
                String(
                    exam?.id ??
                    exam?.exam_type_id ??
                    exam?.exam_id
                )
            ] =
                grade !== null &&
                grade !== undefined &&
                grade !== ""
                    ? String(grade).toUpperCase()
                    : "-";
        });
    });

    return Object.values(skillMap);
};

    const getGradeMidPercentage = (grade, gradingLegend = []) => {
        const g = gradingLegend.find(x => x.grade === grade);
        if (!g) return null;

        return (Number(g.min_percentage) + Number(g.max_percentage)) / 2;
    };

    const getFinalGradeFromLegend = (gradesObj, gradingLegend = []) => {
        const percentages = Object.values(gradesObj)
            .map(g => getGradeMidPercentage(g, gradingLegend))
            .filter(p => p !== null);

        if (!percentages?.length) return "-";

        const avgPercentage =
            percentages.reduce((a, b) => a + b, 0) / percentages?.length;

        return getGradeFromLegend(avgPercentage, gradingLegend);
    };

    const handleDownloadAll = () => {
        const element = document.getElementById("all-marksheets");

        if (!element) return;

        const opt = {
            margin: 0.5,
            filename: "All_Students_Marksheet.pdf",
            image: { type: "png", quality: 0.98 },
            html2canvas: {
                scale: 2,
                useCORS: true,
            },
            jsPDF: {
                unit: "in",
                format: "a4",
                orientation: "portrait",
            },
        };

        html2pdf().set(opt).from(element).save();
    };

    // ---------- Print pagination ----------
    // Chrome does not repeat a <tfoot> taller than ~1/4 page, so for print each
    // marksheet is split into real A4 pages here and the footer is placed at
    // the bottom of every page.
    const PX_PER_MM = 96 / 25.4;
    const PAGE_CONTENT_MM = 277;     // 297mm - 2 x 10mm padding
    const PAGE_GAP_MM = 3;           // space between content and footer

    // page being filled (set by buildPrintPages)
    let pageTopPx = 0;
    let pageSpacePx = 0;

    const canSplitNode = (el) => {
        // marks table (subjects + curriculum + total) prints as one block;
        // it is split only when moving it would leave this page mostly empty
        if (el.classList.contains("keep-together")) {
            const rect = el.getBoundingClientRect();
            return (
                rect.height > pageSpacePx ||
                rect.top - pageTopPx < pageSpacePx / 2
            );
        }
        if (el.tagName === "TABLE") return true;
        if (el.tagName !== "DIV" || el.children.length === 0) return false;
        if (window.getComputedStyle(el).display !== "block") return false;
        // don't split a div that mixes text with elements
        return !Array.from(el.childNodes).some(
            n => n.nodeType === 3 && n.textContent.trim() !== ""
        );
    };

    const isEmptyNode = (el) =>
        el.tagName === "TABLE"
            ? !Array.from(el.rows).some(r => r.parentNode.tagName !== "THEAD")
            : el.children.length === 0;

    // Keeps table rows above breakY in `table`, returns a new table with the
    // rest (header row repeated).
    const splitTable = (table, breakY) => {
        const rest = table.cloneNode(false);
        if (table.tHead) rest.appendChild(table.tHead.cloneNode(true));

        const bodyRows = Array.from(table.rows).filter(
            r => r.parentNode.tagName !== "THEAD"
        );
        let start = bodyRows.findIndex(
            r => r.getBoundingClientRect().bottom > breakY + 0.5
        );
        if (start === -1) return null;

        // Curriculum / Total rows stay attached to the subject row above them
        while (start > 0 && bodyRows[start].classList.contains("keep-with-prev-row")) {
            start--;
        }

        const sections = new Map();

        bodyRows.slice(start).forEach(row => {
            const parent = row.parentNode;

            if (parent === table) {
                rest.appendChild(row);
                return;
            }
            if (!sections.has(parent)) {
                const section = parent.cloneNode(false);
                sections.set(parent, section);
                rest.appendChild(section);
            }
            sections.get(parent).appendChild(row);
        });

        return rest;
    };

    // Keeps the part of `node` above breakY in place and returns a clone
    // holding everything below it (or null when it all fits).
    const splitNode = (node, breakY) => {
        if (node.tagName === "TABLE") return splitTable(node, breakY);

        const rest = node.cloneNode(false);
        const children = Array.from(node.children);
        const rects = children.map(c => c.getBoundingClientRect());
        let moving = false;

        children.forEach((child, idx) => {
            if (moving) {
                rest.appendChild(child);
                return;
            }
            if (rects[idx].height === 0 || rects[idx].bottom <= breakY + 0.5) return;

            moving = true;

            // e.g. Remarks: never leave it alone on the next page - carry the
            // last rows of the table above along so it stays right below it
            if (child.classList.contains("keep-with-prev") && idx > 0) {
                // nearest earlier block that is actually visible
                let prevIdx = idx - 1;
                while (prevIdx > 0 && rects[prevIdx].height === 0) prevIdx--;
                const prev = children[prevIdx];
                const prevTable =
                    prev.tagName === "TABLE"
                        ? prev
                        : Array.from(prev.querySelectorAll("table")).pop();
                const bodyRows = prevTable
                    ? Array.from(prevTable.rows).filter(
                        r => r.parentNode.tagName !== "THEAD"
                    )
                    : [];

                if (bodyRows.length > 2 && !prevTable.classList.contains("keep-together")) {
                    const carryFrom =
                        bodyRows[bodyRows.length - 2].getBoundingClientRect().top;
                    const tableRest = splitTable(prevTable, carryFrom - 1);
                    if (tableRest) {
                        // whole table carried: don't leave an empty header behind
                        if (isEmptyNode(prevTable)) prevTable.remove();
                        rest.appendChild(tableRest);
                    }
                }
            }

            if (rects[idx].top < breakY && canSplitNode(child)) {
                const childRest = splitNode(child, breakY);
                if (childRest && !isEmptyNode(childRest)) {
                    // everything moved: drop the empty shell left behind
                    if (isEmptyNode(child)) child.remove();
                    rest.appendChild(childRest);
                }
                return;
            }
            rest.appendChild(child);
        });

        return moving ? rest : null;
    };

    const cloneWithImageSizes = (el) => {
        const clone = el.cloneNode(true);
        const originals = el.querySelectorAll("img");
        const copies = clone.querySelectorAll("img");
        originals.forEach((img, idx) => {
            if (!copies[idx]) return;
            copies[idx].style.width = `${img.offsetWidth}px`;
            copies[idx].style.height = `${img.offsetHeight}px`;
        });
        return clone;
    };

    const makePageFooter = (footer, withFootnoteDetails) => {
        const foot = document.createElement("div");
        Array.from(footer.childNodes).forEach(n =>
            foot.appendChild(n.cloneNode(true))
        );
        if (!withFootnoteDetails) {
            foot.querySelectorAll(".footnote-details").forEach(n => n.remove());
        }
        Object.assign(foot.style, {
            position: "absolute",
            left: "10mm",
            right: "10mm",
            bottom: "10mm",
        });
        return foot;
    };

    const buildPrintPages = (source) => {
        const host = document.createElement("div");
        host.style.cssText = "position:absolute;left:-10000px;top:0;";
        document.body.appendChild(host);

        source.querySelectorAll(".marksheet-sheet").forEach(sheet => {
            const content = sheet.querySelector(".marksheet-content");
            const footer = sheet.querySelector(".marksheet-footer");
            if (!content || !footer) return;

            let remaining = cloneWithImageSizes(content);

            for (let pageNo = 0; remaining && pageNo < 10; pageNo++) {
                const page = document.createElement("div");
                page.setAttribute("style", sheet.getAttribute("style") || "");
                Object.assign(page.style, {
                    width: "210mm",
                    height: "297mm",
                    minHeight: "297mm",
                    margin: "0",
                    position: "relative",
                    overflow: "hidden",
                    pageBreakAfter: "always",
                    breakAfter: "page",
                });

                page.appendChild(remaining);
                const fullFoot = makePageFooter(footer, true);
                page.appendChild(fullFoot);
                host.appendChild(page);

                const top = remaining.getBoundingClientRect().top;
                const breakFor = (foot) =>
                    top +
                    PAGE_CONTENT_MM * PX_PER_MM -
                    foot.offsetHeight -
                    PAGE_GAP_MM * PX_PER_MM;

                // Last page: everything left fits with the full footer
                // (footnote details are printed only here)
                const breakFull = breakFor(fullFoot);
                if (remaining.getBoundingClientRect().bottom <= breakFull + 0.5) {
                    // continuation page without Skill / User Observation data:
                    // print what is left in the middle of the page
                    if (
                        pageNo > 0 &&
                        !remaining.querySelector(".skill-table, .observation-table")
                    ) {
                        const middle = document.createElement("div");
                        Object.assign(middle.style, {
                            position: "absolute",
                            left: "10mm",
                            right: "10mm",
                            top: "50%",
                            transform: "translateY(-50%)",
                        });
                        Object.assign(fullFoot.style, {
                            position: "static",
                            marginTop: `${PAGE_GAP_MM}mm`,
                        });
                        page.insertBefore(middle, remaining);
                        middle.appendChild(remaining);
                        middle.appendChild(fullFoot);
                    }
                    break;
                }

                // More pages follow: footer without footnote details
                const foot = makePageFooter(footer, false);
                page.replaceChild(foot, fullFoot);
                const breakY = breakFor(foot);
                pageTopPx = top;
                pageSpacePx = breakY - top;

                let next = splitNode(remaining, breakY);

                // content fits only with the shorter footer: keep it all on
                // this page, footnote details go on the next page
                if (!next) {
                    remaining = remaining.cloneNode(false);
                    continue;
                }

                // first block taller than a page: leave it, don't loop forever
                if (next && remaining.children.length === 0) {
                    page.insertBefore(next, foot);
                    page.removeChild(remaining);
                    break;
                }
                remaining = next;
            }
        });

        const pages = host.children;
        if (pages.length) {
            pages[pages.length - 1].style.pageBreakAfter = "auto";
            pages[pages.length - 1].style.breakAfter = "auto";
        }

        const html = host.innerHTML;
        document.body.removeChild(host);
        return html;
    };

    const handlePrintMarksheet = () => {
        const printContents = document.getElementById("all-marksheets");
        if (!printContents) return;

        window.scrollTo(0, 0);
        const pagesHtml = buildPrintPages(printContents);
        const originalContents = document.body.innerHTML;

        document.body.innerHTML =
            `<style>
                @page { size: A4 portrait; margin: 0; }
                body { margin: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            </style>` + pagesHtml;
        window.scrollTo(0, 0);

        // logo jaisi images load hone ke baad hi print karo, warna kata/blank aata hai
        const images = Array.from(document.body.querySelectorAll("img"));
        const imagesLoaded = images.map(img =>
            img.complete
                ? Promise.resolve()
                : new Promise(resolve => {
                    img.onload = resolve;
                    img.onerror = resolve;
                })
        );
        const timeout = new Promise(resolve => setTimeout(resolve, 5000));

        Promise.race([Promise.all(imagesLoaded), timeout]).then(() => {
            requestAnimationFrame(() => {
                window.print();
                document.body.innerHTML = originalContents;
                window.location.reload();
            });
        });
    };
    // const handlePrintMarksheet = () => {
    //     window.print();
    // };
    const convertImageToBase64 = async (url) => {
        try {
            const response = await fetch(url, {
                mode: "cors",
            });

            const blob = await response.blob();

            return await new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onloadend = () => resolve(reader.result);

                reader.onerror = reject;

                reader.readAsDataURL(blob);
            });
        } catch (error) {
            console.log("Base64 Error:", error);
            return null;
        }
    };
    const [DownloadLoading, setDownloadLoading] = useState(false);

    const handleDownloadAll2 = async () => {

        try {

            setDownloadLoading(true);

            const element = document.getElementById("all-marksheets");

            if (!element) {
                setDownloadLoading(false);
                return;
            }

            const opt = {
                margin: [0, 0, 0, 0],

                filename: "All_Students_Marksheet.pdf",

                image: {
                    type: "jpeg",
                    quality: 1,
                },

                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    allowTaint: true,
                },

                jsPDF: {
                    unit: "px",
                    format: [element.scrollWidth, element.scrollHeight],
                    orientation: "portrait",
                },
            };

            await html2pdf()
                .set(opt)
                .from(element)
                .save();

            setDownloadLoading(false);

        } catch (error) {

            console.log(error);

            setDownloadLoading(false);
        }
    };

    const getStatusSymbol = (attendance) => {
        if (!attendance) return "";

        const { status, leave_type } = attendance;

        if (status === "leave") {
            return leave_type === "medical" ? "L" : "ML";
        }

        if (status === "absent") return "1";

        if (status === "present") return "";

        return "";
    };

    const allowedStudentIds = studentTransferData?.map(
        (s) => Number(s?.student_id)
    );

    let hasNotMarked = false;
    // const getMedicalLeaveExplanation = (f) => {
    //     return `Due to medical leave in the ${f.subject} paper, ${f.marks} marks obtained in ${f.refExam} have been used as reference instead of ${f.originalExam}.`;
    // };
    const getMedicalLeaveExplanation = (f) => {

        // ref_exam nahi hai to kuch mat dikhao
        if (!f.refExam) return "";

        return `Due to medical leave in the ${f.subject} paper, ${f.marks} marks obtained in ${f.refExam} have been used as reference instead of ${f.originalExam}.`;
    };

    const getAttendanceBadge = (status) => {
        switch (status?.toLowerCase()) {
            case "absent":
                return { text: "Ab", color: "red" };

            case "present":
                return { text: "P", color: "green" };

            case "leave":
                return { text: "L", color: "#d4a000" };

            case "medical leave":
            case "medical_leave":
            case "medical":
                return { text: "ML", color: "#d4a000" };

            default:
                return { text: status || "", color: "#000" };
        }
    };

    return (
        <div className="page-wrapper bg-light marksheet-page">
            <div className="content">
            <Header />
            <style>{`
                @media (max-width: 991.98px) {
                    .marksheet-page > .content { padding-left: 0; padding-right: 0; }
                    .marksheet-page .marksheet-container { padding: 12px 8px 90px; }
                    .marksheet-toolbar .btn { font-size: 13px; padding: 6px 10px; }
                }
            `}</style>
            <Container fluid className="py-4 marksheet-container">

                {loading && (
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                            position: "absolute",
                            inset: 0,
                            background: "rgba(255,255,255,0.7)",
                            zIndex: 9999
                        }}
                    >
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                )}

                <Row className="mb-3 marksheet-toolbar">
                    <Col className="d-flex justify-content-end flex-wrap gap-2">
                        <Button
                            onClick={() => navigate(-1)}
                            className="btn btn-light border"
                            style={{ backgroundColor: "#6c757d", border: "1px solid #6c757d", color: "white", }}
                        >
                            <FaArrowCircleLeft /> Back
                        </Button>

                        <Button variant="secondary" onClick={handlePrintMarksheet}>
                            <FiFileText /> Print Marksheet
                        </Button>

                    </Col>
                </Row>

                <div
                    ref={fitWrapRef}
                    style={{
                        width: "100%",
                        overflow: "hidden",
                        height: sheetScale < 1 && sheetHeight ? `${sheetHeight}px` : "auto",
                    }}
                >
                <div
                    ref={fitInnerRef}
                    style={{
                        width: "210mm",
                        margin: sheetScale < 1 ? 0 : "0 auto",
                        transform: sheetScale < 1 ? `scale(${sheetScale})` : "none",
                        transformOrigin: "top left",
                    }}
                >
                {/* Header */}
                <div className="all-marksheets" id="all-marksheets">
                    {[...(students?.data || [])]
                        ?.filter((student) =>
                            allowedStudentIds?.includes(
                                Number(student?.student_id)
                            )
                        )
                        ?.sort(
                            (a, b) =>
                                Number(a?.roll_num || 0) -
                                Number(b?.roll_num || 0)
                        )
                        ?.map((studentData, index) => {

                            const transferInfo = studentTransferData?.find(
                                (s) => Number(s?.student_id) === Number(studentData?.student_id)
                            );
                            const sectionChangeData = studentData?.section_change_data || [];
                            const sectionChangeStudent = {
                                ...studentData,
                                exam_type:
                                    studentData?.section_change_data?.[0]?.exam_type || []
                            };

                            const sectionData = buildSubjectRows(
                                sectionChangeStudent,
                                students?.GradingLegend
                            );
                            const sectionExamColumns =
                                sectionChangeStudent.exam_type?.filter(
                                    e => e.exam_type !== "Overall"
                                ) || [];

                            const sectionTotals = calculateColumnTotals(
                                sectionData,
                                sectionExamColumns,
                                students?.GradingLegend
                            );



                            const subjectRows = buildSubjectRows(studentData, students?.GradingLegend);
                            const curriculumRows = buildCurriculumRows(studentData);

                            const currentSubjectIds = new Set(
                                subjectRows.map(row => String(row.subject_id))
                            );

                            // console.log("Current Subjects:", [...currentSubjectIds]);

                            const filteredSectionData = sectionData.filter(
                                row => !currentSubjectIds.has(String(row.subject_id))
                            );

                            const examColumns = studentData.exam_type?.filter(
                                e => e.exam_type !== "Overall"
                            );
                            const totals = calculateColumnTotals(
                                subjectRows,
                                examColumns,
                                students?.GradingLegend
                            );

                            const percentage = totals.percentage;
                            const overallGrade = totals.grade;


                            const examColumnsTotal = examColumns.reduce(
                                (sum, exam) => sum + (totals.exams[exam.exam_type] || 0),
                                0
                            );

                            const skillRows = buildSkillRows(studentData);
                            const skillExamColumns = getSkillExamColumns(studentData);                            

                            const userobservationdata = studentData?.userObserv;
                            let mlCounter = 0;
                            let reexamCounter = 0;
                            let leaveCounter = 0;
                            let absentCounter = 0;
                            let hasAbsent = false;
                            let hasLeave = false;
                            const footNotes = [];
                            const hasBelowMinimumMarks =
                                subjectRows?.some(row =>
                                    Object.values(row.examDetails || {}).some(
                                        details =>
                                            !row?.isGradeInputType &&
                                            details?.belowMin === true
                                    )
                                );


                            return (

                                <div key={studentData?.student_id ?? index} className="mb-4">
                                    <div
                                        className="marksheet-sheet"
                                        style={{
                                            ...container,
                                            pageBreakAfter: "always",
                                            breakAfter: "page"
                                        }}>

                                        {/* Print wrapper: tfoot repeats on every printed page */}
                                        <table style={pageTable}>
                                        <tbody>
                                        <tr>
                                        <td style={pageBodyCell}>
                                        <div className="marksheet-content">

                                        <div
                                            style={{
                                                display: "inline-block",
                                                alignItems: "center",
                                                gap: "15px",
                                                width: "100%",
                                                borderBottom: "2px solid #ccc",
                                                paddingBottom: "10px",
                                            }}
                                        >
                                            <img
                                                src={students?.schoolData?.schoolLogo}
                                                crossOrigin="anonymous"

                                                alt="logo"
                                                style={{
                                                    width: "17%",
                                                    display: "inline-block",
                                                    verticalAlign: "top",
                                                }}
                                            />

                                            <div
                                                style={{
                                                    width: "75%",
                                                    textAlign: "center",
                                                    display: "inline-block",
                                                }}
                                            >
                                                <h2 style={{ marginBottom: 0 }}>{students?.schoolData?.schoolName}</h2>
                                                <p>
                                                    {students?.schoolData?.schoolAddress} <br />
                                                    {/* {students?.schoolData?.aboutUs} */}
                                                    {/* <br /> */}
                                                    Contact: {students?.schoolData?.contact_number} | {students?.schoolData?.email}
                                                </p>
                                            </div>
                                            <img
                                                // src={students?.schoolData?.schoolImage}
                                                // src="assets/img/cbsc-logo.png"
                                                src={students?.schoolData?.cbse_state_logo}
                                                crossOrigin="anonymous"

                                                alt="logo"
                                                style={{
                                                    width: "8%",
                                                    display: "inline-block",
                                                    verticalAlign: "top",
                                                }}
                                            />
                                        </div>

                                        {/* ------------- STUDENT DETAILS ------------- */}

                                        <div style={{ marginTop: "10px" }}>
                                            <div style={row}>
                                                <span>
                                                    <b>Student's Name:</b> {studentData?.student_full_name}
                                                </span>
                                                <span>
                                                    <b>Roll No:</b> {studentData?.roll_num}
                                                </span>
                                            </div>

                                            <div style={row}>
                                                {studentData?.father_full_name &&
                                                    studentData?.father_full_name?.toLowerCase() !== "null" ? (
                                                    <span>
                                                        <b>Father's Name:</b> {studentData?.father_full_name}
                                                    </span>
                                                ) : (
                                                    <span></span>
                                                )}
                                                <span>
                                                    <b>Class/Section:</b> {studentData.cls_sec?.cls?.Classes} - {studentData?.cls_sec?.section?.section}
                                                </span>
                                            </div>

                                            <div style={row}>
                                                {studentData?.mother_full_name &&
                                                    studentData?.mother_full_name?.toLowerCase() !== "null" ? (
                                                    <span>
                                                        <b>Mother's Name:</b> {studentData?.mother_full_name}
                                                    </span>
                                                ) : (
                                                    <span></span>
                                                )}
                                                <span>
                                                    <b>Total Present Days:</b> {transferInfo?.present}
                                                </span>

                                            </div>
                                            <div style={row}>
                                                <span>
                                                    <b>Admission No:</b> {studentData?.admission_num}
                                                </span>
                                                <span>
                                                    <b>Total Working Days:</b> {transferInfo?.workingDays}
                                                </span>
                                            </div>
                                            <div style={row}>
                                                <span>
                                                    <b>DOB:</b> {studentData?.date_of_birth?.split("T")[0]}
                                                </span>
                                                {/* <span>
                                                <b>T. Attendance in(%):</b> {transferInfo?.calculated_percentage}
                                            </span> */}
                                                <span>
                                                    <b>T. Attendance (%):</b>{" "}
                                                    {Number(transferInfo?.calculated_percentage).toFixed(2)}
                                                </span>

                                            </div>

                                        </div>

                                        {/* ------------- MARKS TABLE ------------- */}
                                        <table className="keep-together" style={table}>
                                            <thead>

                                                <tr>
                                                    <th style={{ ...th, width: "25%", fontSize:'12px', fontWeight:'bold' }}>Subject</th>
                                                    {/* {studentData?.exam_type
                                                        ?.filter(exam => exam.exam_type !== "Overall")
                                                        .map((exam) => (
                                                            <th style={{ ...th, width: "12%" }}>{exam?.exam_type}</th>

                                                        ))} */}
                                                        {studentData?.exam_type
    ?.filter(exam => exam.exam_type !== "Overall")?.map((exam, index) => (
        <th key={index} style={{ ...th, width: "12%" }}>
            {exam?.exam_type}
            {!["XI", "XII"].includes(String(studentData?.cls_sec?.cls?.Classes || "").trim().toUpperCase()) &&
                getExamHeaderWeightage(exam, subjectRows) > 0 &&
                ` (${getExamHeaderWeightage(exam, subjectRows)})`}
        </th>
    ))}
                                                    <th style={{ ...th, width: "12%" }}>Total</th>
                                                    <th style={{ ...th, width: "12%" }}>Max Marks</th>
                                                    <th style={{ ...th, width: "12%" }}>Grade</th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                {subjectRows.map((row, i) => {
                                                    const hasMedicalLeave = Object.values(row.examDetails || {}).some(
                                                        d => d?.attendance?.status === "leave" &&
                                                            d?.attendance?.leave_type === "medical" &&
                                                            (d.obtained === null || d.obtained === 0)
                                                    );

                                                    // if (hasMedicalLeave) {
                                                    //     let max = 0;
                                                    //     examColumns.forEach((exam) => {
                                                    //         const details = row.examDetails?.[exam.exam_type];
                                                    //         if (!details) return;
                                                    //         max += Number(details.weightage || 0);
                                                    //     });

                                                    //     row.maxMarks = max;
                                                    //     row.total = "-";
                                                    //     row.percentage = "-"; // ✅ Safe fallback
                                                    //     row.grade = "-";
                                                    //     return;
                                                    // }
                                                    return (
                                                        <tr key={i}>
                                                            <td style={{ ...tdLeft, width: "25%" }}><b>{row.subject}</b></td>
                                                            {examColumns?.map(exam => {
                                                                const details = row.examDetails?.[exam.exam_type];

                                                                const percent = row?.exams?.[exam.exam_type]; // number OR grade string
                                                                const obtained = details?.obtained;
                                                                const maxMarks = details?.max_marks;

                                                                const status = details?.attendance?.status;   // 🔥 from API
                                                                const attendance = details?.attendance;

                                                                const minMarks = details?.min_marks || 0;

                                                                const isMedicalLeave =
                                                                    details?.attendance?.status === "leave" &&
                                                                    details?.attendance?.leave_type === "medical";

                                                                // const showRedUnderline =
                                                                //     !row?.isGradeInputType &&
                                                                //     !isMedicalLeave &&
                                                                //     details?.obtained !== null &&
                                                                //     details?.obtained !== undefined &&
                                                                //     Number(details?.obtained) < Number(minMarks);


// Final marks (original exam vs re-exam)
const finalMarks = getHighestExamMarks(details);

// Weightage calculation
const weightage = Number(details?.weightage || 0);

const weightedMarks =
  maxMarks > 0
    ? (Number(finalMarks || 0) / maxMarks) * weightage
    : 0;

// Red underline condition
const showRedUnderline =
  !row?.isGradeInputType &&
  !isMedicalLeave &&
  details?.belowMin === true; // paper-wise weighted mark_obtain < weighted min_marks



                                                                // const symbol = getStatusSymbol(details?.attendance);
                                                                const isNotMarked =
                                                                    (percent === undefined ||
                                                                        percent === null ||
                                                                        percent === "") &&
                                                                    !attendance?.status;

                                                                // ✅ SET FLAG
                                                                if (isNotMarked) {
                                                                    hasNotMarked = true;
                                                                }


                                                                let symbol = "";

                                                                if (attendance?.status === "absent") {

                                                                    absentCounter++;

                                                                    symbol = `Ab${absentCounter}`;

                                                                    hasAbsent = true;
                                                                }

                                                                else if (
                                                                    attendance?.status === "leave" &&
                                                                    attendance?.leave_type !== "medical"
                                                                ) {

                                                                    leaveCounter++;

                                                                    symbol = `L${leaveCounter}`;

                                                                    hasLeave = true;
                                                                }

                                                                else if (
                                                                    attendance?.status === "leave" &&
                                                                    attendance?.leave_type === "medical"
                                                                ) {

                                                                    mlCounter++;

                                                                    symbol = `ML${mlCounter}`;

                                                                    const refExamName =
                                                                        details?.ref_exam?.name || null;

                                                                    footNotes.push({
                                                                        tag: `ML${mlCounter}`,
                                                                        reason: "Medical Leave",
                                                                        subject: row.subject,
                                                                        originalExam: exam.exam_type,
                                                                        refExam: refExamName,

                                                                        marks: row.isGradeInputType
                                                                            ? details?.grade
                                                                            : details?.ref_marks || details?.obtained || 0,

                                                                        grade: row.grade
                                                                    });
                                                                }


                                                                if (details?.reExamList?.length > 0) {
                                                                    reexamCounter++;
                                                                    symbol = `Re${reexamCounter}`;

                                                                    const weightage = details?.weightage || exam.weightage;

                                                                    // 🔹 Original weighted marks
                                                                    const originalWeighted =
                                                                        details?.originalMarks && details?.max_marks
                                                                            ? getWeightedMarks(details.originalMarks, weightage, details.max_marks)
                                                                            : "-";

                                                                    const originalMarks = details?.originalMarks
                                                                        ? `${originalWeighted}/${weightage}` : "-";

                                                                    const reMarksList = details?.reExamList.map((re) => {
                                                                        const weighted = getWeightedMarks(re.marks, weightage, re.max);
                                                                        // return `${re.marks}/${re.max} → ${weighted}`;
                                                                        return `${weighted}/${weightage}`;
                                                                    });

                                                                    footNotes.push({
                                                                        tag: `Re${reexamCounter}`,
                                                                        subject: row.subject,
                                                                        originalExam: exam.exam_type,
                                                                        refExam: "Re-Exam",
                                                                        reason: "Re-Examination",
                                                                        // originalMarks,
                                                                        originalWeighted,   // 👈 NEW
                                                                        // reMarks: reMarksList,
                                                                        grade: row.grade,
                                                                        reMarks: details?.reExamList,
                                                                        history: details.resultHistory,
                                                                        originalAttendance: details?.attendance?.status,

                                                                        originalMarks: details.originalMarks,
                                                                        // originalStatus: details?.status || "Approved",
                                                                        originalStatus: details?.status,
                                                                    });


                                                                }

                                                                // console.log(footNotes, "footNotes Re-Exam data");



                                                                return (
                                                                    <td key={exam.exam_type} style={{ ...td, width: "12%" }}>
                                                                        <div
                                                                            style={{
                                                                                display: "grid",
                                                                                gridTemplateColumns: "1fr auto 1fr",
                                                                                alignItems: "center",
                                                                                width: "100%",
                                                                                fontWeight: "bold",
                                                                                position: 'relative',
                                                                                gap: '4px'
                                                                            }}
                                                                        >
                                                                            <span></span>


                                                                            {/* <span style={{ textAlign: "center" }}> */}
                                                                            <span
                                                                                style={{
                                                                                    textAlign: "center",
                                                                                    textDecoration: showRedUnderline
                                                                                        ? "underline"
                                                                                        : "none",

                                                                                    textDecorationColor: showRedUnderline
                                                                                        ? "red"
                                                                                        : "",

                                                                                    textDecorationThickness:
                                                                                        showRedUnderline
                                                                                            ? "3px"
                                                                                            : "",

                                                                                    textUnderlineOffset:
                                                                                        showRedUnderline
                                                                                            ? "3px"
                                                                                            : ""
                                                                                }}
                                                                            >


                                                                                {details?.reExamList?.length > 0 ? (() => {

                                                                                    const finalMarks = getHighestExamMarks(details);

                                                                                    return row?.is_display_grade
                                                                                        ? getGradeFromLegend(
                                                                                            calculatePercentage(
                                                                                                finalMarks,
                                                                                                details?.max_marks || 0
                                                                                            ),
                                                                                            students?.GradingLegend
                                                                                        )
                                                                                        : toWeighted(finalMarks, details);

                                                                                })()
                                                                                    : attendance?.status === "absent" ? (

                                                                                        details?.obtained ?? "0"

                                                                                    ) : attendance?.status === "leave" &&
                                                                                        attendance?.leave_type === "medical" ? (

                                                                                        row?.is_display_grade
                                                                                            ? getGradeFromLegend(
                                                                                                calculatePercentage(
                                                                                                    details?.ref_exam?.mark_obtain ||
                                                                                                    details?.obtained ||
                                                                                                    0,
                                                                                                    details?.max_marks || 0
                                                                                                ),
                                                                                                students?.GradingLegend
                                                                                            )
                                                                                            : toWeighted(details?.ref_exam?.mark_obtain ||
                                                                                            details?.obtained, details) ||
                                                                                            "-"

                                                                                    ) : row?.isGradeInputType ? (

                                                                                        percent || "-"

                                                                                    ) : row?.is_display_grade ? (

                                                                                        details?.obtained !== null &&
                                                                                            details?.obtained !== undefined
                                                                                            ? getGradeFromLegend(
                                                                                                calculatePercentage(
                                                                                                    details.obtained,
                                                                                                    details.max_marks || 0
                                                                                                ),
                                                                                                students?.GradingLegend
                                                                                            )
                                                                                            : "-"

                                                                                    ) : (
                                                                                        details?.obtained !== null &&
                                                                                            details?.obtained !== undefined
                                                                                            ? toWeighted(details.obtained, details)
                                                                                            : "-"
                                                                                    )}

                                                                            </span>
                                                                            {symbol?.length > 0 && (
                                                                                <span
                                                                                    style={{
                                                                                        marginLeft: "2px",
                                                                                        fontWeight: "bold",
                                                                                        color:
                                                                                            symbol.startsWith("Ab")
                                                                                                ? "red"
                                                                                                : symbol.startsWith("L") ||
                                                                                                    symbol.startsWith("ML")
                                                                                                    ? "#d4a000"
                                                                                                    : "#000"
                                                                                    }}
                                                                                >
                                                                                    {!isNotMarked && (() => {

                                                                                        const text =
                                                                                            symbol.match(/[A-Za-z]+/)?.[0];

                                                                                        const number =
                                                                                            symbol.match(/\d+/)?.[0];

                                                                                        return (
                                                                                            <>
                                                                                                {text}
                                                                                                <sup
                                                                                                    style={{
                                                                                                        fontSize: "8px"
                                                                                                    }}
                                                                                                >
                                                                                                    {number}
                                                                                                </sup>
                                                                                            </>
                                                                                        );

                                                                                    })()}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                    </td>


                                                                );
                                                            })}
                                                            <td style={{ ...td, width: "12%" }}>
                                                                <b>{row.total}</b>
                                                                {/* <b>{hasMedicalLeave
                                                                    ? "-"
                                                                    : row.total}</b> */}
                                                            </td>

                                                            <td style={{ ...td, width: "12%" }}>
                                                               <b> {row.maxMarks}</b>
                                                            </td>

                                                            

                                                            <td style={{ ...td, width: "12%" }}>
                                                                <b>{row.grade}</b>
                                                                {/* <b>{hasMedicalLeave
                                                                    ? "-"
                                                                    : row.grade}</b> */}
                                                            </td>
                                                            {/* <td style={{ ...td, width: "12%" }}>
    {hasMedicalLeave
        ? "-"
        : row.percentage
        ? `${row.percentage}% (${row.grade})`
        : row.grade || "-"}
</td> */}
                                                        </tr>
                                                    )
                                                })}

                                                {curriculumRows?.map((c, i) => {
                                                    const finalGrade = getFinalGradeFromLegend(
                                                        c.grades,
                                                        students?.GradingLegend
                                                    );

                                                    return (
                                                        <tr key={i} className="keep-with-prev-row">
                                                            <td style={tdLeft}><b>{c.title}</b></td>

                                                            {examColumns?.map(exam => (
                                                                <td key={exam.exam_type} style={td}>
                                                                    <b>{c.grades[exam.exam_type] ?? "-"}</b>
                                                                </td>
                                                            ))}

                                                            <td style={td}>-</td>
                                                            <td style={td}>-</td>

                                                            <td style={td}>
                                                                <b>{finalGrade}</b>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}


                                                <tr className="keep-with-prev-row">
                                                    <td style={tdLeft}>
                                                        <b>Total</b>
                                                    </td>

                                                    {examColumns?.map(exam => (
                                                        <td key={exam.exam_type} style={td}>
                                                            <b>{totals.exams[exam.exam_type]}</b>
                                                        </td>
                                                    ))}



                                                   
                                                    {/* Total + Percentage */}
                                                    <td style={td}>
                                                        <b>
                                                            {totals.total}
                                                            {/* <br />
                                                        <small>({percentage}%)</small> */}
                                                        </b>
                                                    </td>
                                                     {/* Max Marks */}
                                                    <td style={td}>
                                                        <b>{totals.max}</b>
                                                    </td>


                                                    {/* Grade */}
                                                    <td style={td}>
                                                        <b>{overallGrade}</b>
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>


                                        {/* ------------- CONSOLIDATED PERFORMANCE ------------- */}
                                        <table style={{ ...table, marginTop: "10px" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={tdLeft2}>
                                                        <b>Consolidated Performance:- </b>
                                                    </td>
                                                    <td style={tdLeft}>
                                                        <b>Maximum Marks:</b> {totals.max}
                                                    </td>
                                                    <td style={tdLeft}>
                                                        <b>Marks Obtained:</b> {totals.total}
                                                    </td>
                                                    <td style={tdLeft}>
                                                        <b>Percentage: </b> {percentage !== "-" ? `${Number(percentage).toFixed(2)}%` : "-"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>


                                        

                                        {visibilityOptions?.is_skill_visible === true && (
    <table className="skill-table" style={table}>
        <thead>
            <tr>
                <th style={th}>
                    Co-Scholastic Area (A–C Grade)
                </th>

                {skillExamColumns.map((exam, index) => (
                    <th key={index} style={th}>
                        {exam?.exam_type}
                    </th>
                ))}
            </tr>
        </thead>

        <tbody>
            {skillRows?.length > 0 ? (
                skillRows.map((skill, index) => (
                    <tr key={index}>
                        <td style={tdLeft}>
                            <b>{skill.skillCategory}</b>
                        </td>

                        {skillExamColumns.map((exam) => {
                            const examId = String(
                                exam?.id ??
                                exam?.exam_type_id ??
                                exam?.exam_id
                            );

                            const grade =
                                skill?.grades?.[examId];

                            return (
                                <td
                                    key={examId}
                                    style={td}
                                >
                                    <b>
                                        {grade !== null &&
                                        grade !== undefined &&
                                        grade !== ""
                                            ? String(
                                                  grade
                                              ).toUpperCase()
                                            : "-"}
                                    </b>
                                </td>
                            );
                        })}
                    </tr>
                ))
            ) : (
                <tr>
                    <td style={tdLeft}>
                        No skills data
                    </td>

                    {skillExamColumns.map((exam) => (
                        <td
                            key={
                                exam?.id ??
                                exam?.exam_type_id ??
                                exam?.exam_id
                            }
                            style={td}
                        >
                            -
                        </td>
                    ))}
                </tr>
            )}
        </tbody>
    </table>
)}

                                        {/* ------------- User Observation AREA ------------- */}
                                        {userobservationdata?.length > 0 && visibilityOptions?.is_oberv_visible === true && (
                                            <table className="observation-table" style={table}>
                                                <thead>
                                                <tr>
                                                    <th style={{ ...th, width: "20%" }}>Title</th>
                                                    <th style={{ ...th, width: "20%" }}>Behaviour</th>
                                                    <th style={{ ...th, width: "60%" }}>Remarks</th>
                                                </tr>
                                                </thead>


                                                <tbody>
                                                    {userobservationdata?.map((datauserObser, index) => (
                                                        <tr key={index}>
                                                            <td style={td}>
                                                                <b>{datauserObser?.observation.name?.toUpperCase() || "-"}</b>
                                                            </td>
                                                            {datauserObser?.observation?.is_positive === true ? (
                                                                <td style={td}>
                                                                    <b style={{ color: 'green' }}>Good</b>
                                                                </td>
                                                            ) : (
                                                                <td style={td}>
                                                                    <b style={{ color: 'red' }}>Bad</b>
                                                                </td>
                                                            )}
                                                            <td style={td}>
                                                                {datauserObser?.observation.rmk}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>


                                            </table>
                                        )}

                                        {visibilityOptions?.is_previousclass &&
                                            studentData?.section_change_data?.length > 0 && (

                                                <>
                                                    <h5 className="mt-2 mb-0" style={{fontSize:"12px", fontWeight:'bold'}}>
                                                        Previous Class ({getClassSectionLabel(studentData?.section_change_data?.[0]?.from_class_section_id)}) Result
                                                    </h5>



                                                    <table style={table1}>
                                                        <thead>

                                                            <tr>
                                                                <th style={{ ...th, width: "25%" }}>Subject</th>
                                                                {sectionExamColumns.map((exam) => (
                                                                    <th key={exam.exam_type} style={{ ...th, width: "12%" }}>
                                                                        {exam?.exam_type}
                                                                         {!["XI", "XII"].includes(String(studentData?.cls_sec?.cls?.Classes || "").trim().toUpperCase()) &&
                                                                            getExamHeaderWeightage(exam, filteredSectionData) > 0 &&
                                                                            ` (${getExamHeaderWeightage(exam, filteredSectionData)})`} 
                                                                    </th>

                                                                ))}
                                                                <th style={{ ...th, width: "12%" }}>Total</th>
                                                                <th style={{ ...th, width: "12%" }}>Max Marks</th>
                                                                <th style={{ ...th, width: "12%" }}>Grade</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>

                                                            {filteredSectionData.map((row, i) => {
                                                                const hasMedicalLeave = Object.values(row.examDetails || {}).some(
                                                                    d => d?.attendance?.status === "leave" &&
                                                                        d?.attendance?.leave_type === "medical" &&
                                                                        (d.obtained === null || d.obtained === 0)
                                                                );

                                                                // if (hasMedicalLeave) {
                                                                //     let max = 0;
                                                                //     examColumns.forEach((exam) => {
                                                                //         const details = row.examDetails?.[exam.exam_type];
                                                                //         if (!details) return;
                                                                //         max += Number(details.weightage || 0);
                                                                //     });

                                                                //     row.maxMarks = max;
                                                                //     row.total = "-";
                                                                //     row.percentage = "-"; // ✅ Safe fallback
                                                                //     row.grade = "-";
                                                                //     return;
                                                                // }
                                                                return (
                                                                    <tr key={i}>
                                                                        <td style={{ ...tdLeft, width: "25%" }}><b>{row.subject}</b></td>
                                                                        {sectionExamColumns.map(exam => {
                                                                            const details = row.examDetails?.[exam.exam_type];

                                                                            const percent = row?.exams?.[exam.exam_type]; // number OR grade string
                                                                            const obtained = details?.obtained;
                                                                            const maxMarks = details?.max_marks;

                                                                            const status = details?.attendance?.status;   // 🔥 from API
                                                                            const attendance = details?.attendance;

                                                                            const minMarks = details?.min_marks || 0;

                                                                            const isMedicalLeave =
                                                                                details?.attendance?.status === "leave" &&
                                                                                details?.attendance?.leave_type === "medical";

                                                                            // const showRedUnderline =
                                                                            //     !row?.isGradeInputType &&
                                                                            //     !isMedicalLeave &&
                                                                            //     details?.obtained !== null &&
                                                                            //     details?.obtained !== undefined &&
                                                                            //     Number(details?.obtained) < Number(minMarks);


                                                                              
// Final marks (original exam vs re-exam)
const finalMarks = getHighestExamMarks(details);

// Weightage calculation
const weightage = Number(details?.weightage || 0);

const weightedMarks =
  maxMarks > 0
    ? (Number(finalMarks || 0) / maxMarks) * weightage
    : 0;

// Red underline condition
const showRedUnderline =
  !row?.isGradeInputType &&
  !isMedicalLeave &&
  details?.belowMin === true; // paper-wise weighted mark_obtain < weighted min_marks



                                                                            // const symbol = getStatusSymbol(details?.attendance);
                                                                            const isNotMarked =
                                                                                (percent === undefined ||
                                                                                    percent === null ||
                                                                                    percent === "") &&
                                                                                !attendance?.status;

                                                                            // ✅ SET FLAG
                                                                            if (isNotMarked) {
                                                                                hasNotMarked = true;
                                                                            }


                                                                            let symbol = "";

                                                                            if (attendance?.status === "absent") {

                                                                                absentCounter++;

                                                                                symbol = `Ab${absentCounter}`;

                                                                                hasAbsent = true;
                                                                            }

                                                                            else if (
                                                                                attendance?.status === "leave" &&
                                                                                attendance?.leave_type !== "medical"
                                                                            ) {

                                                                                leaveCounter++;

                                                                                symbol = `L${leaveCounter}`;

                                                                                hasLeave = true;
                                                                            }

                                                                            else if (
                                                                                attendance?.status === "leave" &&
                                                                                attendance?.leave_type === "medical"
                                                                            ) {

                                                                                mlCounter++;

                                                                                symbol = `ML${mlCounter}`;

                                                                                const refExamName =
                                                                                    details?.ref_exam?.name || null;

                                                                                footNotes.push({
                                                                                    tag: `ML${mlCounter}`,
                                                                                    reason: "Medical Leave",
                                                                                    subject: row.subject,
                                                                                    originalExam: exam.exam_type,
                                                                                    refExam: refExamName,

                                                                                    marks: row.isGradeInputType
                                                                                        ? details?.grade
                                                                                        : details?.ref_marks || details?.obtained || 0,

                                                                                    grade: row.grade
                                                                                });
                                                                            }


                                                                            if (details?.reExamList?.length > 0) {
                                                                                reexamCounter++;
                                                                                symbol = `Re${reexamCounter}`;

                                                                                const weightage = details?.weightage || exam.weightage;

                                                                                // 🔹 Original weighted marks
                                                                                const originalWeighted =
                                                                                    details?.originalMarks && details?.max_marks
                                                                                        ? getWeightedMarks(details.originalMarks, weightage, details.max_marks)
                                                                                        : "-";

                                                                                const originalMarks = details?.originalMarks
                                                                                    ? `${originalWeighted}/${weightage}` : "-";

                                                                                const reMarksList = details?.reExamList?.map((re) => {
                                                                                    const weighted = getWeightedMarks(re.marks, weightage, re.max);
                                                                                    // return `${re.marks}/${re.max} → ${weighted}`;
                                                                                    return `${weighted}/${weightage}`;
                                                                                });

                                                                                footNotes.push({
                                                                                    tag: `Re${reexamCounter}`,
                                                                                    subject: row.subject,
                                                                                    originalExam: exam.exam_type,
                                                                                    refExam: "Re-Exam",
                                                                                    reason: "Re-Examination",
                                                                                    // originalMarks,
                                                                                    originalWeighted,   // 👈 NEW
                                                                                    // reMarks: reMarksList,
                                                                                    grade: row.grade,
                                                                                    reMarks: details?.reExamList,
                                                                                    history: details.resultHistory,
                                                                                    originalAttendance: details?.attendance?.status,
                                                                                    originalMarks: details.originalMarks,
                                                                                    // originalStatus: details?.status || "Approved",
                                                                                    originalStatus: details?.status,
                                                                                });


                                                                            }

                                                                            return (
                                                                                <td key={exam.exam_type} style={{ ...td, width: "12%" }}>
                                                                                    <div
                                                                                        style={{
                                                                                            display: "grid",
                                                                                            gridTemplateColumns: "1fr auto 1fr",
                                                                                            alignItems: "center",
                                                                                            width: "100%",
                                                                                            fontWeight: "bold",
                                                                                            position: 'relative',
                                                                                            gap: '4px'
                                                                                        }}
                                                                                    >
                                                                                        <span></span>


                                                                                        {/* <span style={{ textAlign: "center" }}> */}
                                                                                        <span
                                                                                            style={{
                                                                                                textAlign: "center",
                                                                                                textDecoration: showRedUnderline
                                                                                                    ? "underline"
                                                                                                    : "none",

                                                                                                textDecorationColor: showRedUnderline
                                                                                                    ? "red"
                                                                                                    : "",

                                                                                                textDecorationThickness:
                                                                                                    showRedUnderline
                                                                                                        ? "3px"
                                                                                                        : "",

                                                                                                textUnderlineOffset:
                                                                                                    showRedUnderline
                                                                                                        ? "3px"
                                                                                                        : ""
                                                                                            }}
                                                                                        >
                                                                                            {details?.reExamList?.length > 0 ? (() => {

                                                                                                // Original marks
                                                                                                const originalMarks = Number(
                                                                                                    details?.originalMarks ??
                                                                                                    details?.ref_marks ??
                                                                                                    details?.obtained ??
                                                                                                    0
                                                                                                );

                                                                                                // Highest Re-Exam marks
                                                                                                const highestReExamMarks = Math.max(
                                                                                                    ...(details?.reExamList || []).map(r => Number(r.marks || 0)),
                                                                                                    0
                                                                                                );

                                                                                                // Final Highest Marks
                                                                                                const finalMarks = Math.max(originalMarks, highestReExamMarks);

                                                                                                return row?.is_display_grade
                                                                                                    ? getGradeFromLegend(
                                                                                                        calculatePercentage(
                                                                                                            finalMarks,
                                                                                                            details?.max_marks ||
                                                                                                            details?.reExamList?.[0]?.max ||
                                                                                                            0
                                                                                                        ),
                                                                                                        students?.GradingLegend
                                                                                                    )
                                                                                                    : toWeighted(finalMarks, details);

                                                                                            })()

                                                                                                : attendance?.status === "absent" ? (

                                                                                                    details?.obtained ?? "0"

                                                                                                ) : attendance?.status === "leave" &&
                                                                                                    attendance?.leave_type === "medical" ? (

                                                                                                    row?.is_display_grade
                                                                                                        ? getGradeFromLegend(
                                                                                                            calculatePercentage(
                                                                                                                details?.ref_exam?.mark_obtain ||
                                                                                                                details?.obtained ||
                                                                                                                0,
                                                                                                                details?.max_marks || 0
                                                                                                            ),
                                                                                                            students?.GradingLegend
                                                                                                        )
                                                                                                        : toWeighted(details?.ref_exam?.mark_obtain ||
                                                                                                        details?.obtained, details) ||
                                                                                                        "-"

                                                                                                ) : row?.isGradeInputType ? (

                                                                                                    percent || "-"

                                                                                                ) : row?.is_display_grade ? (

                                                                                                    details?.obtained !== null &&
                                                                                                        details?.obtained !== undefined
                                                                                                        ? getGradeFromLegend(
                                                                                                            calculatePercentage(
                                                                                                                details.obtained,
                                                                                                                details.max_marks || 0
                                                                                                            ),
                                                                                                            students?.GradingLegend
                                                                                                        )
                                                                                                        : "-"

                                                                                                ) : (
                                                                                                    details?.obtained !== null &&
                                                                                                        details?.obtained !== undefined
                                                                                                        ? toWeighted(details.obtained, details)
                                                                                                        : "-"
                                                                                                )}


                                                                                        </span>
                                                                                        {symbol?.length > 0 && (
                                                                                            <span
                                                                                                style={{
                                                                                                    marginLeft: "2px",
                                                                                                    fontWeight: "bold",
                                                                                                    color:
                                                                                                        symbol.startsWith("Ab")
                                                                                                            ? "red"
                                                                                                            : symbol.startsWith("L") ||
                                                                                                                symbol.startsWith("ML")
                                                                                                                ? "#d4a000"
                                                                                                                : "#000"
                                                                                                }}
                                                                                            >
                                                                                                {!isNotMarked && (() => {

                                                                                                    const text =
                                                                                                        symbol.match(/[A-Za-z]+/)?.[0];

                                                                                                    const number =
                                                                                                        symbol.match(/\d+/)?.[0];

                                                                                                    return (
                                                                                                        <>
                                                                                                            {text}
                                                                                                            <sup
                                                                                                                style={{
                                                                                                                    fontSize: "8px"
                                                                                                                }}
                                                                                                            >
                                                                                                                {number}
                                                                                                            </sup>
                                                                                                        </>
                                                                                                    );

                                                                                                })()}
                                                                                            </span>
                                                                                        )}
                                                                                    </div>
                                                                                </td>


                                                                            );
                                                                        })}
                                                                        

                                                                        <td style={{ ...td, width: "12%" }}>
                                                                            <b>{hasMedicalLeave
                                                                                ? "-"
                                                                                : row.total}</b>
                                                                        </td>
                                                                        <td style={{ ...td, width: "12%" }}>
                                                                            <b>{row.maxMarks}</b>
                                                                        </td>

                                                                        <td style={{ ...td, width: "12%" }}>
                                                                            <b>{hasMedicalLeave
                                                                                ? "-"
                                                                                : row.grade}
                                                                                </b>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}




                                                            <tr>
                                                                <td style={tdLeft}>
                                                                    <b>Total</b>
                                                                </td>
                                                                {sectionExamColumns.map(exam => (

                                                                    <td style={th}>
                                                                        {sectionTotals.exams?.[exam.exam_type]}
                                                                    </td>

                                                                ))}
                                                                <td style={th}>
                                                                    <b>{sectionTotals.total}</b>
                                                                </td>
                                                                <td style={th}>
                                                                    <b>{sectionTotals.max}</b>
                                                                </td>

                                                                <td style={th}>
                                                                    <b>{sectionTotals.grade}</b>
                                                                </td>
                                                            </tr>

                                                        </tbody>
                                                    </table>


                                                </>
                                            )}


                                        {/* ------------- REMARKS ------------- */}
                                        {visibilityOptions?.is_remarks === true && (
                                            <div className="keep-with-prev" style={{ marginTop: "10px", width: '100%', color: '#000', display: 'inline-block' }}>
                                                <p style={{ width: '10%', marginBottom:'0px', color: '#000', display: 'inline-block', verticalAlign: 'top' }}><b>Remarks:</b> </p>
                                                <p style={{ width: '90%',  marginBottom:'0px', color: '#000', display: 'inline-block', fontSize:'13px' }}>
                                                    Child {studentData?.student_full_name}'s progress has been steady, and
                                                    he/she is ready for the next level of academic challenge.
                                                    {/* He/She has been passed and promoted to next Class. */}
                                                </p>
                                            </div>
                                        )}




                                        </div>
                                        </td>
                                        </tr>
                                        </tbody>

                                        {/* ------------- FOOTER (repeats on every printed page) ------------- */}
                                        <tfoot>
                                        <tr>
                                        <td className="marksheet-footer" style={pageFooterCell}>
                                        {/* ------------- SIGNATURES ------------- */}
                                        <div style={{ padding: '0px 10px'}}>
                                            <div style={signatureRow}>
                                                <div style={signatureBlock}>
                                                    __________________ <br /> <b>Class Teacher</b>
                                                </div>
                                                <div style={signatureBlock}>
                                                    __________________ <br /> <b>Coordinator</b>
                                                </div>

                                                <div style={signatureBlock}>
                                                    __________________ <br /><b>Principal</b>
                                                </div>
                                            </div>

                                            {/* ------------- GRADING LEGEND ------------- */}
                                            <div style={{ marginTop: "10px", width: "100%" }}>
                                                <span style={{fontSize:'12px'}}><b>GRADING LEGEND (SCHOLASTIC AREAS)</b></span>

                                                <table
                                                    style={{
                                                        width: "100%",
                                                        borderCollapse: "collapse",
                                                        marginTop: "2px",
                                                        fontSize: "12px",
                                                        textAlign: "center",
                                                    }}
                                                >

                                                    <tr>
                                                        <th
                                                            style={{
                                                                border: "1px solid #000",
                                                                padding: "3px",
                                                                background: "#f7f4b5", // yellow background like screenshot
                                                                fontWeight: "bold",
                                                                width: "120px",
                                                            }}
                                                        >
                                                            Marks Range
                                                        </th>
                                                        {students?.GradingLegend?.map((g, i) => (
                                                            <th style={{ ...cell1 }}>{g.min_percentage}% - {g.max_percentage}%</th>
                                                        ))}
                                                    </tr>

                                                    {/* Second Row - Grades */}
                                                    <tr>
                                                        <th
                                                            style={{
                                                                border: "1px solid #000",
                                                                padding: "3px",
                                                                background: "#f7f4b5",
                                                                fontWeight: "bold",
                                                            }}
                                                        >
                                                            Grade
                                                        </th>

                                                        {/* Grade Columns */}
                                                        {students?.GradingLegend?.map((g, i) => (
                                                            <td style={cell1}>{g.grade} {g.remarks}</td>
                                                        ))}
                                                    </tr>
                                                </table>
                                            </div>
                                            {(
                                                hasNotMarked ||
                                                hasAbsent ||
                                                hasLeave ||
                                                footNotes?.length > 0 ||
                                                hasBelowMinimumMarks
                                            ) && (
                                                    <div
                                                        style={{
                                                            // marginTop: "5px",
                                                            fontSize: "12px",
                                                            // borderTop: "1px solid #ccc",
                                                            paddingTop: "8px",
                                                        }}
                                                    >
                                                        {/* FOOT NOTES TITLE */}
                                                        <div style={{ fontWeight: "bold", marginBottom: "0px" }}>
                                                            Notes :
                                                        </div>

                                                        <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>

                                                            {/* {[
                                                                hasAbsent && ( */}
                                                            <span>
                                                                <b style={{ color: "red" }}>
                                                                    Ab
                                                                </b>{" "}
                                                                : Absent
                                                            </span>
                                                            {/* ),

                                                                hasLeave && ( */}
                                                            <span>
                                                                <b style={{ color: "#d4a000" }}>
                                                                    L
                                                                </b>{" "}
                                                                : Leave
                                                            </span>
                                                            {/* ),

                                                                hasNotMarked && ( */}
                                                            <span>
                                                                <b>-</b> : Not Marked
                                                            </span>
                                                            {/* ),

                                                                hasBelowMinimumMarks && ( */}
                                                            <span>
                                                                <b
                                                                    style={{
                                                                        color: "red",
                                                                        textDecoration: "underline",
                                                                        textDecorationColor: "red",
                                                                        textDecorationThickness: "3px"
                                                                    }}
                                                                >
                                                                    ___
                                                                </b>{" "}
                                                                : {"<"} Min Marks
                                                            </span>
                                                            {/* ),

                                                                footNotes?.length > 0 && ( */}
                                                            <span>
                                                                <b style={{ color: "#d4a000" }}>
                                                                    ML
                                                                </b>{" "}
                                                                : Medical Leave
                                                            </span>
                                                            {/* ),

                                                                footNotes?.some(f => f.tag.startsWith("Re")) && ( */}
                                                            <span>
                                                                <b style={{ color: "#000" }}>
                                                                    Re
                                                                </b>{" "}
                                                                : Re-Examination
                                                            </span>
                                                            {/* ),
                                                            ] */}
                                                            {/* .filter(Boolean)
                                                                .map((item, index, arr) => (
                                                                    <span key={index}>
                                                                        {item}
                                                                        {index < arr.length - 1 && " || "}
                                                                    </span>
                                                                ))} */}
                                                        </div>

                                                        {/* FOOTNOTE DETAILS - footer ke niche */}
                                                        <div className="footnote-details" style={{ fontSize: "12px", color: "#000", marginTop: "4px" }}>


                                                        {/* REFERENCE MARKS */}
                                                        {footNotes?.some(
                                                            f => f?.reason === "Medical Leave" && f?.refExam
                                                        ) && (
                                                                <>
                                                                    <div
                                                                        style={{
                                                                            marginTop: "8px",
                                                                            fontWeight: "bold",
                                                                        }}
                                                                    >
                                                                        Reference Marks :
                                                                    </div>

                                                                    <div style={{ marginTop: "4px", lineHeight: "1.8" }}>
                                                                        {footNotes
                                                                            ?.filter(
                                                                                f =>
                                                                                    f?.reason === "Medical Leave" &&
                                                                                    f?.refExam
                                                                            )
                                                                            ?.map((f, i) => (
                                                                                // <div key={i}>
                                                                                //     <b>{f.tag}</b> :{" "}
                                                                                //     {getMedicalLeaveExplanation(f)}
                                                                                // </div>
                                                                                <div key={i}>
                                                                                    <span
                                                                                        style={{
                                                                                            color: "#d4a000",
                                                                                            fontWeight: "bold"
                                                                                        }}
                                                                                    >
                                                                                        {(() => {

                                                                                            const text =
                                                                                                f.tag.match(/[A-Za-z]+/)?.[0];

                                                                                            const number =
                                                                                                f.tag.match(/\d+/)?.[0];

                                                                                            return (
                                                                                                <>
                                                                                                    {text}
                                                                                                    <sup
                                                                                                        style={{
                                                                                                            fontSize: "9px",
                                                                                                            color: "#d4a000",
                                                                                                            fontWeight: "bold"
                                                                                                        }}
                                                                                                    >
                                                                                                        {number}
                                                                                                    </sup>
                                                                                                </>
                                                                                            );

                                                                                        })()}
                                                                                    </span>

                                                                                    {" : "}

                                                                                    {getMedicalLeaveExplanation(f)}
                                                                                </div>
                                                                            ))}
                                                                    </div>
                                                                </>
                                                            )}

                                                        {footNotes
                                                            .filter(f => f.reMarks?.length)
                                                            .map((f, i) => (
                                                                <div key={i} style={{ marginTop: "6px" }}>

                                                                    <b>
                                                                        {f.tag}
                                                                    </b>

                                                                    {" : "}



                                                                    {f.subject
                                                                        ? f.subject.charAt(0).toUpperCase() + f.subject.slice(1).toLowerCase() : ""}


                                                                    {"  "}

                                                                    Marks :
                                                                    <b>{f.originalMarks}/{f.reMarks[0]?.max}</b>

                                                                    {f.originalAttendance && (
                                                                        <>
                                                                            {" "}
                                                                            (
                                                                            <span
                                                                                style={{
                                                                                    color: getAttendanceBadge(f.originalAttendance).color,
                                                                                    fontWeight: "bold"
                                                                                }}
                                                                            >
                                                                                {getAttendanceBadge(f.originalAttendance).text}
                                                                            </span>
                                                                            )
                                                                        </>
                                                                    )}

                                                                    {/* {f.reMarks.map((re, idx) => {

             const history = f.history?.find(
        h => h.tag === f.reMarks[0]?.tag && h.is_reexam
    );

    const attendance = history?.attendance;

    const badge = getAttendanceBadge(
        attendance?.status,
        attendance?.leave_type
    );
    
    // const history = f.history?.find(
    //     h => h.tag === re.tag && h.is_reexam
    // );

    // const attendance = history?.attendance;

    // const badge = getAttendanceBadge(
    //     attendance?.status,
    //     attendance?.leave_type
    // );

    const total = f.reMarks.reduce(
        (acc, re) => {
            acc.marks += Number(re.marks || 0);
            acc.max += Number(re.max || 0);
            return acc;
        },
        { marks: 0, max: 0 }
    );

    // Attendance first re-exam se le lo
   
    return (
        <small style={{ fontSize: "11px" }}>
            {" "}
            R1: <b>{total.marks}/{total.max}</b>

            {attendance && (
                <span
                    style={{
                        color: badge.color,
                        fontWeight: "bold"
                    }}
                >
                    {" "}
                    ({badge.text})
                </span>
            )}
        </small>
    );
})} */}

                                                                    {(() => {
                                                                        // Re1, Re2... ke hisaab se marks group karo
                                                                        const grouped = f.reMarks.reduce((acc, item) => {
                                                                            if (!acc[item.tag]) {
                                                                                acc[item.tag] = {
                                                                                    marks: 0,
                                                                                    max: 0,
                                                                                };
                                                                            }

                                                                            acc[item.tag].marks += Number(item.marks || 0);
                                                                            acc[item.tag].max += Number(item.max || 0);

                                                                            return acc;
                                                                        }, {});

                                                                        return Object.entries(grouped).map(([tag, total], index) => {
                                                                            // Is Re tag ki history nikalo
                                                                            const matchedHistory = f.history?.find(
                                                                                (h) => h.tag === tag && h.is_reexam
                                                                            );

                                                                            const attendance = matchedHistory?.attendance;

                                                                            const badge = attendance
                                                                                ? getAttendanceBadge(
                                                                                    attendance.status,
                                                                                    attendance.leave_type
                                                                                )
                                                                                : null;

                                                                            return (
                                                                                <small key={tag} style={{ fontSize: "11px" }}>
                                                                                    {index > 0 && " | "}

                                                                                    {tag}: <b>{total.marks}/{total.max}</b>

                                                                                    {" "}

                                                                                    {attendance ? (
                                                                                        <span
                                                                                            style={{
                                                                                                color: badge.color,
                                                                                                fontWeight: "bold",
                                                                                            }}
                                                                                        >
                                                                                            ({badge.text})
                                                                                        </span>
                                                                                    ) : (
                                                                                        <span>(-)</span>
                                                                                    )}
                                                                                </small>
                                                                            );
                                                                        });
                                                                    })()}
                                                                </div>
                                                            ))
                                                        }
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                        </td>
                                        </tr>
                                        </tfoot>
                                        </table>


                                    </div>
                                </div>
                            )
                        })}
                </div>
                </div>
                </div>

            </Container>
            </div>
        </div>
    );
};

export default MarksheetView;